import { z } from 'zod';
import { ID_LENGTH } from '../constants.ts';

// nanoid(21) ids. We don't validate the alphabet strictly (nanoid's default set),
// only the length, to keep it cheap and forward-compatible.
export const idSchema = z.string().length(ID_LENGTH);

// Unix epoch milliseconds. All timestamps in the system are integers, not Dates.
export const unixMsSchema = z.number().int().nonnegative();

// Cursor pagination (cursor = last id seen). See docs/03 conventions.
export const paginationQuerySchema = z.object({
  cursor: idSchema.optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

export function pageSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    // next cursor is null when there are no more pages.
    next_cursor: idSchema.nullable(),
  });
}

// Standard error envelope: `{ error: { code, message } }` (docs/03).
export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;
